import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

function initProductSpecifications() {
  const handleVariantUpdate = /** @param {VariantUpdateEvent} event */ (event) => {
    if (event.detail.data?.newProduct) {
      return;
    }

    const responseHtml = event.detail.data?.html;
    if (!responseHtml) return;

    const currentSpecsEl = document.querySelector('[data-product-specifications]');
    if (!currentSpecsEl) return;

    const sectionId = currentSpecsEl.getAttribute('data-section-id');
    if (!sectionId) return;

    const wrapperId = `shopify-section-${sectionId}`;
    const currentWrapper = document.getElementById(wrapperId);
    const newWrapper = responseHtml.getElementById(wrapperId);

    if (!currentWrapper || !newWrapper) return;

    morph(currentWrapper, newWrapper, {
      childrenOnly: false,
    });
  };

  document.addEventListener(ThemeEvents.variantUpdate, handleVariantUpdate);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductSpecifications);
} else {
  initProductSpecifications();
}
